export function normalizeTransportAddressList(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value
      .map(formatTransportAddressEntry)
      .filter(Boolean);
  }

  if (value === null || value === undefined) {
    return [];
  }

  const trimmed = formatTransportAddressEntry(value);
  return trimmed ? [trimmed] : [];
}

function formatTransportAddressEntry(entry: unknown): string {
  if (entry === null || entry === undefined) {
    return '';
  }

  if (typeof entry !== 'object') {
    return String(entry).trim();
  }

  const record = entry as Record<string, unknown>;
  const values: string[] = [];
  const push = (value: unknown) => {
    const text = String(value ?? '').trim();
    if (text && !values.includes(text)) {
      values.push(text);
    }
  };

  push(record.name);
  push(record.companyName);
  push(record.address);
  push([record.postalCode, record.city].map((part) => String(part ?? '').trim()).filter(Boolean).join(' '));
  push(record.country);

  return values.join(', ');
}

